"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportedRegions = void 0;
exports.SupportedRegions = {
    assignment: ['GB', 'DE', 'AT', 'BR']
};
//# sourceMappingURL=supportedRegions.js.map